$(document).ready(function () {
  toggleClassOnCustomerFieldsLabels();

  function toggleClassOnCustomerFieldsLabels() {
    let fieldsContainer = $('.js-customer-fields');

    if (!fieldsContainer.length) {
      return;
    }

    fieldsContainer.on("change", "input[type='checkbox']", function(e) {
     if ($(this).prop('checked')) {
       $(this).parents('label').addClass('cf-input-checked');
     } else {
       $(this).parents('label').removeClass('cf-input-checked');
     }
    });
  }
  
  if (CF) {
    CF.ready(function() {
      //Check on page load 
      console.log('CUSTOMER FIELDS LOADED');
      $('#customer-fields-preferences input[type="checkbox"]').each(function() {
        if ($(this).prop('checked')) {
          $(this).parents('label').addClass('cf-input-checked');
        } else {
          $(this).parents('label').removeClass('cf-input-checked');
        }
      });
    });
  }
});